var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 18,
    viewBox: "0 0 133 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00592613 18H6.53418L6.53418 1.00001H0.00592613L0.00592613 18Z",
    fill: "url(#paint0_linear_164_14455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0616 18H16.5898L16.5898 1.00001H10.0616L10.0616 18Z",
    fill: "url(#paint1_linear_164_14455)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1044 18H26.6387L26.6387 1.00001H20.1044V18Z",
    fill: "url(#paint2_linear_164_14455)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3661 2.88735V16.0814H32.1509V2.88735H95.3661ZM97.3157 0.984375H30.1895V17.9844H97.3334V1.00166L97.3157 0.984375Z",
    fill: "url(#paint3_linear_164_14455)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.048 3.80469L120.156 9.50211L110.048 15.1995V3.80469Z",
    fill: "url(#paint4_linear_164_14455)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.892 3.80469L133 9.50211L122.892 15.1995V3.80469Z",
    fill: "url(#paint5_linear_164_14455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_14455",
    x1: 90.7102,
    y1: 9.50001,
    x2: -972.917,
    y2: 9.50001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_14455",
    x1: 9367.92,
    y1: 9512,
    x2: -2385.16,
    y2: 9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_164_14455",
    x1: 9386.55,
    y1: 9512,
    x2: -2377.43,
    y2: 9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_164_14455",
    x1: 96277.1,
    y1: 9511.97,
    x2: -24606.3,
    y2: 9511.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_164_14455",
    x1: 1662.11,
    y1: 171.764,
    x2: -16536.4,
    y2: 171.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_164_14455",
    x1: 1674.95,
    y1: 171.764,
    x2: -16523.6,
    y2: 171.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL7);
export default __webpack_public_path__ + "static/media/l7.a5b9529539995d1af1e5594302c29567.svg";
export { ForwardRef as ReactComponent };